<div class="message__container">
    <div class="message">
        {{ message }}
    </div>
</div>